import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../../components/Common/Loader/Loader";
import {
  setPollPreviewList,
  setPollUserGroup,
  setTenantPollUsers,
} from "../../../../../store/actions/actionCreators/socialActionCreator";
import {
  getPollUserGroupsHandler,
  getPollUserGroupsSocialHandler,
  getTenantPollUsersHandler,
} from "../../../../../store/actions/actionHandlers/socialActionHandler";
import classes from "./DistributePollTabs.module.scss";
import { FormattedMessage } from "react-intl";

const DistributePolls = ({ activeTab, usersData, setUsersData }) => {
  const dispatch = useDispatch();
  const socialState = useSelector((state) => state.socialReducer);
  const {
    teanantPollUsers,
    pollUserGroups,
    distributePollLoading,
    pollPreviewList,
  } = socialState;

  const [selectedData, setSelectedData] = useState([]);

  const handleCheckBox = (data) => {
    const updatedData = usersData?.map((item) => {
      if (activeTab === 1 && item?.LoginId === data?.LoginId) {
        return { ...item, isChecked: data?.isChecked ? false : true };
      } else if (activeTab === 2 && item?.UserGroupId === data?.UserGroupId) {
        return { ...item, isChecked: data?.isChecked ? false : true };
      } else return item;
    });
    setUsersData(updatedData);
    if (activeTab === 1) dispatch(setTenantPollUsers(updatedData));
    else dispatch(setPollUserGroup(updatedData));

    const checkedRowData = updatedData?.filter((item) => {
      if (activeTab === 1) return item?.LoginId === data?.LoginId;
      else return item?.UserGroupId === data?.UserGroupId;
    });
    if (checkedRowData?.[0]?.isChecked) {
      checkedRowData[0].type = activeTab === 1 ? "User" : "User Group";
      setSelectedData([...selectedData, checkedRowData?.[0]]);
    } else {
      const updatedCheckedRowData = selectedData?.filter((item) => {
        if (activeTab === 1)
          return item?.LoginId !== checkedRowData?.[0]?.LoginId;
        else return item?.UserGroupId !== checkedRowData?.[0]?.UserGroupId;
      });
      setSelectedData(updatedCheckedRowData);
    }
  };

  const handleClearAll = () => {
    const updatedCheckedRowData = usersData?.map((item) => {
      if (item.isChecked) item.isChecked = false;
      return item;
    });
    setUsersData(updatedCheckedRowData);
    const previewListData = selectedData?.filter((item) => {
      if (activeTab === 1) return item?.type !== "User";
      else return item?.type !== "User Group";
    });
    setSelectedData(previewListData);
  };

  useEffect(() => {
    if (activeTab === 1 && teanantPollUsers) {
      setUsersData(teanantPollUsers);
    }
    if (activeTab === 2 && pollUserGroups) {
      setUsersData(pollUserGroups);
    }
    if (activeTab === 3 && selectedData) {
      setUsersData(selectedData);
    }
  }, [pollUserGroups, teanantPollUsers, selectedData, activeTab, setUsersData]);

  useEffect(() => {
    if (activeTab === 2) {
      dispatch(getPollUserGroupsSocialHandler(true, pollPreviewList));
    }
    if (activeTab === 1) {
      dispatch(getTenantPollUsersHandler(true, pollPreviewList));
    }
  }, [activeTab, dispatch]);

  useEffect(() => {
    if (selectedData) dispatch(setPollPreviewList(selectedData));
  }, [selectedData, dispatch]);

  return (
    <div className={classes.pollUsers}>
      {((activeTab === 1 && teanantPollUsers) ||
        (activeTab === 2 && pollUserGroups)) && (
        <div className={classes.clearAllTextDiv}>
          <span onClick={handleClearAll} className={classes.clearAllText}>
            <FormattedMessage id="CLEAR_ALL_TXT" />
          </span>
        </div>
      )}
      <div
        className={
          usersData && !distributePollLoading
            ? classes.pollUsersList
            : classes.pollLoading
        }
      >
        {usersData && !distributePollLoading ? (
          usersData?.map((data, index) => {
            return (
              <div key={index}>
                <div className={classes.border}></div>
                <div className={classes.pollUser}>
                  <div className={classes.pollUserItem}>
                    <p>
                      {activeTab === 1 &&
                        data &&
                        data?.FirstName &&
                        data?.LastName &&
                        data?.FirstName + " " + data?.LastName}
                      {activeTab === 2 && data?.Name}
                      {activeTab === 3 &&
                        data?.type === "User" &&
                        data?.FirstName + "(" + data?.LoginId + ")"}
                      {activeTab === 3 &&
                        data?.type === "User Group" &&
                        data?.Name}
                    </p>
                    {((activeTab === 1 && data?.LoginId) ||
                      (activeTab === 2 && data?.UserGroupId)) && (
                      <input
                        className={classes.userCheckbox}
                        name="userCheckbox"
                        type="checkbox"
                        checked={data?.isChecked}
                        onChange={() => handleCheckBox(data)}
                      />
                    )}
                    {activeTab === 3 && <p>{data?.type}</p>}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <Loader height="7%" width="7%" />
        )}
      </div>
    </div>
  );
};

export default DistributePolls;
